import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';
import { CreditCard, Upload, ArrowLeft } from 'lucide-react';

const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [proofFile, setProofFile] = useState(null);
  const [base64Image, setBase64Image] = useState(""); // Dosya verisi için yeni state
  const item = location.state?.item;

  if (!item) {
    navigate('/');
    return null;
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProofFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result); // Dosyayı metin formatına çevir
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Kullanıcı kontrolü
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      toast({ title: "Hata", description: "Lütfen önce giriş yapın.", variant: "destructive" });
      return;
    }

    const orders = JSON.parse(localStorage.getItem('orders') || '[]');
    
    const newOrder = {
      id: Date.now(),
      userId: user.id,
      userName: user.name,
      userEmail: user.email,
      item: item,
      status: 'pending',
      date: new Date().toISOString(),
      proofImage: base64Image, // DOSYANIN KENDİSİNİ BURAYA EKLİYORUZ
      proofFileName: proofFile?.name || 'Bekleniyor'
    };
    
    orders.push(newOrder);
    localStorage.setItem('orders', JSON.stringify(orders));
    
    toast({
      title: 'Sipariş Oluşturuldu!',
      description: 'Ödeme onayı bekleniyor. Yöneticiler inceleyecek.',
    });
    
    setTimeout(() => {
      navigate('/dashboard');
    }, 1500);
  };

  const periodText = {
    monthly: 'Aylık',
    sixMonth: '6 Aylık',
    yearly: 'Yıllık'
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-green-400 hover:text-green-300 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Link>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-green-400 mb-6">Sipariş Özeti</h2>
            <div className="space-y-4">
              <div>
                <p className="text-gray-400 text-sm">Paket</p>
                <p className="text-white font-semibold text-lg">{item.name}</p>
              </div>
              {item.selectedPeriod && (
                <div>
                  <p className="text-gray-400 text-sm">Süre</p>
                  <p className="text-white font-semibold">{periodText[item.selectedPeriod]}</p>
                </div>
              )}
              <div className="border-t border-green-500/30 pt-4 mt-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-400">Tutar</span>
                  <span className="text-white font-semibold">{item.price} TL</span>
                </div>
                <div className="flex justify-between items-center border-t border-green-500/30 pt-4 mt-4">
                  <span className="text-white font-bold text-lg">Toplam</span>
                  <span className="text-green-400 font-bold text-2xl">{item.price} TL</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl p-8">
            <div className="flex items-center mb-6">
              <CreditCard className="w-6 h-6 text-green-400 mr-2" />
              <h2 className="text-2xl font-bold text-green-400">Ödeme Bilgileri</h2>
            </div>
            
            <div className="bg-gray-800/50 rounded-xl p-6 mb-6 text-sm">
              <p className="text-gray-300 mb-2 font-bold">IBAN / KART:</p>
              <p className="text-white font-mono bg-black/50 p-2 rounded border border-green-500/20 mb-4">4169 7388 7056 3149</p>
              <p className="text-gray-400">Alıcı: Swenzy Bot Hizmetleri</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="proof" className="text-white mb-2 block">Dekont Yükle</Label>
                <label className="flex items-center justify-center w-full px-4 py-3 bg-gray-800 border-2 border-dashed border-green-500/30 rounded-lg cursor-pointer hover:border-green-500 transition-all">
                  <Upload className="w-5 h-5 text-green-400 mr-2" />
                  <span className="text-gray-300 text-sm truncate">
                    {proofFile ? proofFile.name : 'Dosya Seç (Resim)'}
                  </span>
                  <input id="proof" type="file" className="hidden" onChange={handleFileChange} accept="image/*" />
                </label>
              </div>

              <Button type="submit" className="w-full bg-green-500 hover:bg-green-600 text-black font-bold py-3">
                Siparişi Onayla
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;